import type { ReactElement, ReactNode } from 'react';
import { Box, ButtonRow } from '@ksyos/design-system';
import { Children, cloneElement } from 'react';
import { styled } from 'styled-components';

export interface IOverlayTemplateProps {
    children: ReactNode;
    leftButtons?: ReactElement[] | ReactElement;
    maxWidth?: string;
    rightButtons?: ReactElement[] | ReactElement;
}

export function OverlayTemplate(props: IOverlayTemplateProps) {
    const hasFooter = !!props.leftButtons && !!props.rightButtons;

    return (
        <StyledOverlayTemplate>
            <StyledOverlayInner $hasFooter={hasFooter}>
                <StyledOverlayContainer $maxWidth={props.maxWidth}>{props.children}</StyledOverlayContainer>
            </StyledOverlayInner>
            {props.leftButtons && props.rightButtons && (
                <StyledOverlayFooter>
                    <StyledOverlayContainerFooter>
                        <Box
                            display="flex"
                            flexDirection={['column-reverse', 'row']}
                            gap={3}
                            height="100%"
                            justifyContent="space-between"
                            paddingY={4}
                        >
                            <ButtonRow isStackedBelowSmall={true}>
                                {Children.map(props.leftButtons, (button: ReactElement, index) => {
                                    return cloneElement(button, { key: index });
                                })}
                            </ButtonRow>
                            <ButtonRow isStackedBelowSmall={true}>
                                {Children.map(props.rightButtons, (button: ReactElement, index) => {
                                    return cloneElement(button, { key: index });
                                })}
                            </ButtonRow>
                        </Box>
                    </StyledOverlayContainerFooter>
                </StyledOverlayFooter>
            )}
        </StyledOverlayTemplate>
    );
}

const StyledOverlayTemplate = styled.div`
    position: absolute;
    inset: 0;
    z-index: 1000;
    background: #faf9f8;
`;

const StyledOverlayInner = styled.div<{ $hasFooter: boolean }>`
    min-height: ${(props) => (props.$hasFooter ? 'calc(100vh - 72px)' : '100vh')};
    background-color: #faf9f8;
    padding: 40px 0 80px;
`;

const StyledOverlayContainer = styled.div<{ $maxWidth?: string }>`
    width: 100%;
    padding-right: 16px;
    padding-left: 16px;
    margin-right: auto;
    margin-left: auto;
    max-width: ${(props) => props.$maxWidth ?? props.theme.pageLayout.width.small};
`;

const StyledOverlayContainerFooter = styled(StyledOverlayContainer)`
    height: 100%;
`;

const StyledOverlayFooter = styled.div`
    min-height: 72px;
    background-color: white;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    box-shadow: 0 0 32px 0 rgb(219 213 208 / 60%);
    z-index: 999;
`;
